// extracted by mini-css-extract-plugin
export default {"wrapper":"Q66nvl","link":"oc0Gve","icon":"Zy2b7M"};